import React from 'react';
import { useState } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import seal from '../../images/LAPELS-LOLA-Logo.png'
import { Radio, RadioGroup, Form, Input, Schema, AutoComplete, DatePicker } from 'rsuite';
import AuthService from "../../services/auth.service"
import { getFirmCredential } from '../../services/Shared/codeTable.service';
import Swal from 'sweetalert2';
function ForgotUserId() {
    const [inputType, setInputType] = useState("text");
    const [showAccountRecoverEmail, setShowAccountRecoverEmail] = useState(false);
    const push = useNavigate();
    const [firmCreds, setFirmCreds] = useState();
    const updateCreds = (value) => {
        getFirmCredential(value).then(setFirmCreds);
    }
    const [state, setState] = useState({
        isIndividual: "",
        email: "",
        dateOfBirth: null,
        credential: ''
    })
    const { StringType, BooleanType, DateType } = Schema.Types;

    const model = Schema.Model({
        isIndividual: BooleanType().isRequired('This field is required.'),
        email: StringType().isRequired('This field is required.'),
        dateOfBirth: DateType().when(schema => {
            const { value } = schema.isIndividual;
            return value === true ? DateType('Please enter a valid date').isRequired('This field is required.') : DateType('Please enter a valid date');
        }),
        credential: StringType().when(schema => {
            const { value } = schema.isIndividual;
            return value === false ? StringType().isRequired('This field is required.').pattern(/^\(.*\.[0-9]{7}\).*$/, "Please select from the dropdown list.") : StringType();
        }),
    })
    const handleSubmitClick = (validation, event) => {
        if (state.isIndividual) {
            AuthService.forgotIndividualUserId(state.email, new Date(state.dateOfBirth).toISOString()).then((response) => {
                if (response.data.isSuccess) {
                    push("/forgotuseridsuccess");
                }
                else {
                    const toast = Swal.mixin({
                        toast: true,
                        position: 'top',
                        showConfirmButton: false,
                        timer: 5000,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    })
                    toast.fire({
                        icon: 'error',
                        title: "Date of birth does not match email. Please try again."
                    });

                    setShowAccountRecoverEmail(true);
                }
            }, (error) => {
            })
        }
        else {
            AuthService.forgotFirmUserId(state.email, state.credential).then((response) => {
                if (response.data.isSuccess) {
                    push("/forgotuseridsuccess");
                }
                else {
                    const toast = Swal.mixin({
                        toast: true,
                        position: 'top',
                        showConfirmButton: false,
                        timer: 5000,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    })
                    toast.fire({
                        icon: 'error',
                        title: "License Number does not match email. Please try again."
                    });

                    setShowAccountRecoverEmail(true);
                }
            }, (error) => {
            })
        }
    }
    const imageStyle = {
        height: '10rem',
        width: '10rem',
        margin: 'auto'
    };
    const centerText = {
        textAlign: 'center'
    }
    const buttonStyle = {
        width: "100%"
    }

    return (
        <div className="loginPage">
            <Card style={{ width: '25rem', paddingTop: '1rem' }}>
                <Card.Img variant="top" src={seal} alt="Lapels Seal" style={imageStyle} />
                <Card.Body>
                    <Card.Title style={centerText}>Forgot your User Id? Enter email to recover your User Id.</Card.Title>
                    <Form fluid model={model} formValue={state} onChange={state => setState(state)} onSubmit={handleSubmitClick}>
                        <Row className="text-center mb-3">
                            <Col>
                                <Form.Group>
                                    <Form.ControlLabel className="d-none">Choose Role Type</Form.ControlLabel>
                                    <Form.Control name="isIndividual" inline accepter={RadioGroup}>
                                        <Radio value={true}>Individual</Radio>
                                        <Radio value={false}>Firm</Radio>
                                    </Form.Control>
                                    <Form.HelpText className="d-none">Choose Role Type</Form.HelpText>
                                </Form.Group>
                            </Col>
                        </Row>
                        {state.isIndividual !== '' && state.isIndividual &&
                            <>
                                <Form.Group>
                                    <Form.ControlLabel className="d-none">Email</Form.ControlLabel>
                                    <Form.Control accepter={Input} placeholder="Email" name="email" />
                                    <Form.HelpText className="d-none">Email</Form.HelpText>
                                </Form.Group>
                                <Form.Group>
                                    <Form.ControlLabel className="d-none">Date of Birth</Form.ControlLabel>
                                    <Form.Control
                                        accepter={DatePicker}
                                        format="MM/dd/yyyy"
                                        block
                                        name="dateOfBirth"
                                        placeholder="Date of Birth"
                                        oneTap />
                                    <Form.HelpText className="d-none">Date of Birth</Form.HelpText>
                                </Form.Group>
                            </>
                        }
                        {state.isIndividual !== '' && !state.isIndividual &&
                            <>
                                <Form.Group>
                                    <Form.ControlLabel className="d-none">Email</Form.ControlLabel>
                                    <Form.Control accepter={Input} placeholder="Email" name="email" />
                                    <Form.HelpText className="d-none">Email</Form.HelpText>
                                </Form.Group>
                                <Form.Group>
                                    <Form.ControlLabel className="d-none">License Number</Form.ControlLabel>
                                    <Form.Control
                                        accepter={AutoComplete}
                                        block
                                        data={firmCreds}
                                        name="credential"
                                        placeholder="License #"
                                        onChange={updateCreds} />
                                    <Form.HelpText className="d-none">License Number</Form.HelpText>
                                </Form.Group>
                            </>
                        }
                        <Button
                            variant="primary"
                            type="submit"
                            style={buttonStyle}>
                            Send
                        </Button>
                    </Form>
                    <br />
                    {showAccountRecoverEmail == true &&
                        <div className="loginFooter centerText">
                            <p><b>Still can't log in?</b> Please email <a href="mailto:AccountRecovery@lapels.com">AccountRecovery@lapels.com</a></p>
                        </div>}
                    <div className="text-center mt-2">
                        <Card.Link as={Link} to="/login">Back to Login</Card.Link>
                    </div>
                </Card.Body>
            </Card>
        </div>
    );
}

export default ForgotUserId;